import { getObjectUtil } from 'packages/src'

export function getChangedValueReduxUtil (instanceOrPojo, key) {
  if (instanceOrPojo?.changed &&
    Object.prototype.hasOwnProperty.call(instanceOrPojo?.changed, key)) {
    return instanceOrPojo?.changed[key]
  }
}

export function getDataValueReduxUtil (instanceOrPojo, key) {
  if (instanceOrPojo?.data &&
    Object.prototype.hasOwnProperty.call(instanceOrPojo?.data, key)) {
    return instanceOrPojo?.data[key]
  }
}

export function getValueReduxUtil (instanceOrPojo, key) {
  const changedVal = getChangedValueReduxUtil(instanceOrPojo, key)
  if (typeof changedVal !== 'undefined') {
    return changedVal
  }

  const dataVal = getDataValueReduxUtil(instanceOrPojo, key)
  if (typeof dataVal !== 'undefined') {
    return dataVal
  }

  return getObjectUtil(instanceOrPojo, key)
}
